
define(["utils/webpack/mindbreeze_module_map_shared"], function(minimalModuleMap) {
  // if this code is loaded (by the definition of the bundling)
  return function getModuleMap() {
    var moduleMap = minimalModuleMap();

    moduleMap["jquery"] = require("jquery");
    moduleMap["backbone"] = require("backbone");
    moduleMap["bootstrap"] = require("bootstrap");
    moduleMap["bootstrap-daterangepicker/daterangepicker"] = require("bootstrap-daterangepicker/daterangepicker");

    // libs
    moduleMap["jquery-ba-bbq"] = require("libs/jquery-ba-bbq");
    moduleMap["jquery-ui-autocomplete"] = require("libs/jquery-ui-1.13.1.custom");
    moduleMap["libs/apm/softwaretelemetry"] = require("libs/apm/softwaretelemetry");
    moduleMap["jquery-ui-sortable"] = require("libs/jquery-ui-1.13.1.sortable");
    // moduleMap["bootstrap-daterangepicker"] = require("libs/bootstrap-daterangepicker");
    moduleMap["moment"] = require("moment");
    moduleMap["jsoneditor"] = require("libs/jsoneditor");
    moduleMap["client/editor"] = require("client/editor");
    moduleMap["client/templateregistry"] = require("client/templateregistry");
    moduleMap["client/templates"] = require("client/templates");
    moduleMap["client/template"] = require("client/template");
    moduleMap["client/templatetree"] = require("client/templatetree");
    moduleMap["client/sourceinfo"] = require("client/sourceinfo");
    moduleMap["client/resourceinfo"] = require("client/resourceinfo");
    moduleMap["client/layouttree"] = require("client/layouttree");
    moduleMap["client/theme"] = require("client/theme");
    moduleMap["client/default-theme"] = require("client/default-theme");

    moduleMap["client/appfragment/readonly"] = require("client/appfragment/readonly");
    moduleMap["client/appfragment/persisted"] = require("client/appfragment/persisted");
    moduleMap["client/appfragment/builtin"] = require("client/appfragment/builtin");
    moduleMap["client/appfragment/composite"] = require("client/appfragment/composite");

    // Components
    moduleMap["component!actionsheet"] = require("component!actionsheet");
    moduleMap["component!alertcenter"] = require("component!alertcenter");
    moduleMap["component!alertedsearches"] = require("component!alertedsearches");
    moduleMap["component!anchor"] = require("component!anchor");
    moduleMap["component!annotationPopup"] = require("component!annotationPopup");
    moduleMap["component"] = require("component");
    moduleMap["component!base"] = require("component!base");
    moduleMap["component!default"] = require("component!default");
    moduleMap["component!breadcrumb"] = require("component!breadcrumb");
    moduleMap["component!charts"] = require("component!charts");
    moduleMap["component!emailalert"] = require("component!emailalert");
    moduleMap["component!emailalert_preset"] = require("component!emailalert_preset");
    moduleMap["component!feedback"] = require("component!feedback");
    moduleMap["component!clientnotification"] = require("component!clientnotification");
    moduleMap["component!chat"] = require("component!chat");
    moduleMap["component!chatframe"] = require("component!chatframe");
    moduleMap["component!module"] = require("component!module");
    //moduleMap["component!gallery"] = require("component!gallery");
    moduleMap["component!list"] = require("component!list");
    moduleMap["component!map"] = require("component!map");
    moduleMap["component!resultcount"] = require("component!resultcount");
    moduleMap["component!profilesettings"] = require("component!profilesettings");
    moduleMap["component!profilesettingsview"] = require("component!profilesettingsview");
    moduleMap["component!resultfeedback"] = require("component!resultfeedback");
    moduleMap["component!resultsprogress"] = require("component!resultsprogress");
    moduleMap["component!row"] = require("component!row");
    moduleMap["component!resetfilters"] = require("component!resetfilters");
    moduleMap["component!savedsearches"] = require("component!savedsearches");
    moduleMap["component!search"] = require("component!search");
    moduleMap["component!searchdesigner"] = require("component!searchdesigner");
    moduleMap["component!slider"] = require("component!slider");
    moduleMap["component!span"] = require("component!span");
    moduleMap["component!suggestlist"] = require("component!suggestlist");
    moduleMap["component!summarize"] = require("component!summarize");
    moduleMap["component!timeline"] = require("component!timeline");
    moduleMap["component!queryinfo"] = require("component!queryinfo");
    moduleMap["component!gridlayout"] = require("component!gridlayout");
    moduleMap["component!preview"] = require("component!preview");
    moduleMap["model/attribute_proxy"] = require("model/attribute_proxy");
    moduleMap["model/persisted_models"] = require("model/persisted_models");
    moduleMap["model/alertcenter"] = require("model/alertcenter");
    moduleMap["model/filtered_collection"] = require("model/filtered_collection");
    moduleMap["model/tree_collection"] = require("model/tree_collection");
    moduleMap["model/persisted_collection"] = require("model/persisted_collection");
    moduleMap["model/persisted_collection_application_extensions"] = require("model/persisted_collection_application_extensions");
    moduleMap["model/computed"] = require("model/computed");
    moduleMap["model/favorites-adapter"] = require("model/favorites-adapter");
    moduleMap["model/grouped_collection"] = require("model/grouped_collection");
    moduleMap["model/tasks"] = require("model/tasks");
    moduleMap["model/templateinfo"] = require("model/templateinfo");
    moduleMap["model/tabs"] = require("model/tabs");
    moduleMap["model/compute_wiring"] = require("model/compute_wiring");
    moduleMap["model/properties"] = require("model/properties");
    moduleMap["model/readonlytree"] = require("model/readonlytree");
    moduleMap["model/tree"] = require("model/tree");
    moduleMap["model/model_response_observer"] = require("model/model_response_observer");
    moduleMap["service/constrainedchannels"] = require("service/constrainedchannels");
    moduleMap["service/factory"] = require("service/factory");
    moduleMap["service/messageframe_channel"] = require("service/messageframe_channel");
    moduleMap["service/channel"] = require("service/channel");
    moduleMap["service/ajax_channel"] = require("service/ajax_channel");
    moduleMap["service/stub"] = require("service/stub");
    moduleMap["service/open_search_channel"] = require("service/open_search_channel");
    moduleMap["service/channel_factory"] = require("service/channel_factory");
    moduleMap["service/wiring"] = require("service/wiring");
    moduleMap["service/constrained_channel"] =  require("service/constrained_channel");
    moduleMap["service/messageframes"] = require("service/messageframes");
    moduleMap["service/cross_domain_ajax_channel"] = require("service/cross_domain_ajax_channel");
    moduleMap["utils/aria/tooltip"] = require("utils/aria/tooltip");
    moduleMap["utils/aria/dialog"] = require("utils/aria/dialog");
    moduleMap["utils/aria/accordion"] = require("utils/aria/accordion");
    moduleMap["utils/aria/role"] = require("utils/aria/role");
    moduleMap["utils/aria/toolbar"] = require("utils/aria/toolbar");
    moduleMap["utils/events"] = require("utils/events");
    moduleMap["utils/uuid"] = require("utils/uuid");
    moduleMap["utils/flexbox"] = require("utils/flexbox");
    moduleMap["utils/requirejs_plugin_component"] = require("utils/requirejs_plugin_component");
    moduleMap["utils/mustache"] = require("utils/mustache");
    moduleMap["utils/keys"] = require("utils/keys");
    moduleMap["utils/array"] = require("utils/array");
    moduleMap["utils/match-criteria"] = require("utils/match-criteria");
    moduleMap["utils/localStorage"] = require("utils/localStorage");
    moduleMap["utils/dom"] = require("utils/dom");
    moduleMap["utils/resizer"] = require("utils/resizer");
    moduleMap["utils/timer"] = require("utils/timer");
    moduleMap["utils/apptest"] = require("utils/apptest");
    moduleMap["utils/value-binding"] = require("utils/value-binding");
    moduleMap["utils/jsonpath"] = require("utils/jsonpath");
    moduleMap["utils/accessibility"] = require("utils/accessibility");
    moduleMap["utils/task_sequence"] = require("utils/task_sequence");
    moduleMap["utils/coverage"] = require("utils/coverage");
    moduleMap["utils/encode"] = require("utils/encode");
    moduleMap["utils/requirejs_plugin_editor"] = require("utils/requirejs_plugin_editor");
    moduleMap["utils/inplace-edit"] = require("utils/inplace-edit");
    moduleMap["utils/trace"] = require("utils/trace");
    moduleMap["utils/persistedsourceinfo"] = require("utils/persistedsourceinfo");
    moduleMap["utils/clone"] = require("utils/clone");
    moduleMap["utils/jsonpath_parser"] = require("utils/jsonpath_parser");
    moduleMap["utils/source_context_parser"] = require("utils/source_context_parser");
    moduleMap["utils/url"] = require("utils/url");
    moduleMap["utils/lzma-url"] = require("utils/lzma-url");
    moduleMap["utils/lzma-helper"] = require("utils/lzma-helper");
    moduleMap["utils/properties"] = require("utils/properties");
    moduleMap["utils/sourceinfo"] = require("utils/sourceinfo");
    moduleMap["api/v2/common"] = require("api/v2/common");
    moduleMap["api/v2/logout"] = require("api/v2/logout");
    moduleMap["api/v2/resources"] = require("api/v2/resources");
    moduleMap["api/v2/usersourceinfo"] = require("api/v2/usersourceinfo");
    moduleMap["api/v2/applist"] = require("api/v2/applist");
    moduleMap["api/v2/sourceinfo"] = require("api/v2/sourceinfo");
    moduleMap["api/v2/getprofile"] = require("api/v2/getprofile");
    moduleMap["api/v2/export"] = require("api/v2/export");
    moduleMap["api/v2/personalization"] = require("api/v2/personalization");
    moduleMap["api/v2/preview"] = require("api/v2/preview");
    moduleMap["api/v2/suggest"] = require("api/v2/suggest");
    moduleMap["api/v2/models/result"] = require("api/v2/models/result");
    moduleMap["api/v1/mindbreeze/client/notification"] = require("api/v1/mindbreeze/client/notification");
    moduleMap["api/v2/persisted"] = require("api/v2/persisted");
    moduleMap["view/viewfactoryconfig"] = require("view/viewfactoryconfig");
    moduleMap["view/viewfactory"] = require("view/viewfactory");
    moduleMap["extensions"] = require("extensions");
    moduleMap["client/views/list"] = require("client/views/list");
    moduleMap["utils/alert-modal-handler"] = require("utils/alert-modal-handler");
    moduleMap["client/formqueryadapter"] = require("client/formqueryadapter");
    moduleMap["plugin-init"] = require("plugin-init");
    moduleMap["api/chat/v1beta/data"] = require("api/chat/v1beta/data");
    moduleMap["api/chat/v1beta/generate"] = require("api/chat/v1beta/generate");
    moduleMap["@mindbreeze/api-clients"] = require("@mindbreeze/api-clients");
    moduleMap["client/action"] = require("client/action");
   return moduleMap;
  }
});
